"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var remeda_1 = require("remeda");
var isParent = function (node) {
    return typeof node.children !== "undefined" && Array.isArray(node.children);
};
exports.recursiveReduce = function (root, transform) {
    var children = root.children;
    var iteratee = function (path) { return function (accumulator, node, index) {
        if (isParent(node)) {
            var children_1 = node.children;
            var reduced = remeda_1.set(node, "children", children_1.reduce(iteratee(path.concat(index)), []));
            return accumulator.concat(transform(reduced, path, root));
        }
        return accumulator.concat(transform(node, path, root));
    }; };
    return remeda_1.set(root, "children", children.reduce(iteratee([]), []));
    // Typescript complains about this, couldn't figure out why, so switched to
    // set() instead
    // const { children, ...rest } = root;
    // return {
    //   ...rest,
    //   children: children.reduce(iteratee([]), [])
    // };
};
exports.default = exports.recursiveReduce;
